module.exports = __webpack_public_path__ + "static/media/teacher15.27e23bc4.png";